export default "__VITE_ASSET__ebd76860__"